import React, { useState } from "react";
import { Button } from "react-bootstrap";
import DemoTable from "../Demographics/DemoTable";

export default function Demo({
  race,
  ethnicity,
}: {
  race: Data.MiscDemo[];
  ethnicity: Data.MiscDemo[];
}) {
  const [tab, setTab] = useState<"race" | "ethnicity">("race");
  return (
    <>
      <div className="text-sm-center text-lg-right">
        <Button
          variant="link"
          onClick={() => setTab("race")}
          className={`misc-tab ${tab === "race" ? "active" : ""}`}
        >
          Race
        </Button>
        <Button
          variant="link"
          onClick={() => setTab("ethnicity")}
          className={`misc-tab ${tab === "ethnicity" ? "active" : ""}`}
        >
          Ethnicity
        </Button>
      </div>
      <DemoTable
        data={tab === "race" ? race : ethnicity}
        demoType={tab === "race" ? "Race" : "Ethnicity"}
        eventType="Cases"
        showPop={false}
        suppress={false}
      />
    </>
  );
}
